import React from 'react';

function GeolocatedOpportunity({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5 1C17.4704 1 21.5 4.66892 21.5 9.1947C21.5 12.4656 19.6702 14.338 17.8085 16.2431C16.3264 17.7596 14.8241 19.2969 14.2085 21.577C13.6963 23.4743 11.2487 23.4743 10.7364 21.577C10.1182 19.287 8.61636 17.7195 7.14013 16.1787C5.30018 14.2582 3.5 12.3793 3.5 9.1947C3.5 4.66892 7.52958 1 12.5 1ZM10.5 6.25H8.5C7.95 6.25 7.5 6.7375 7.5 7.33333V8.95833C7.5 9.55958 7.945 10.0417 8.5 10.0417H10V8.95833H11V10.0417H14V8.95833H15V10.0417H16.5C17.05 10.0417 17.5 9.55417 17.5 8.95833V7.33333C17.5 6.7375 17.05 6.25 16.5 6.25H14.5V5.70833C14.5 5.10708 14.055 4.625 13.5 4.625H11.5C10.945 4.625 10.5 5.10708 10.5 5.70833V6.25ZM10 10.5833V11.6667H11V10.5833H14V11.6667H15V10.5833H17V13.2917C17 13.8929 16.555 14.375 16 14.375H9C8.445 14.375 8 13.8929 8 13.2917L8.005 10.5833H10ZM11.5 6.25V5.70833H13.5V6.25H11.5Z"
                fill={color}
            />
        </svg>
    );
}

export default GeolocatedOpportunity;
